import { render, staticRenderFns } from "./createEditUPIAccounts.vue?vue&type=template&id=0e1c00a2&scoped=true&"
import script from "./createEditUPIAccounts.vue?vue&type=script&lang=js&"
export * from "./createEditUPIAccounts.vue?vue&type=script&lang=js&"
import style0 from "./createEditUPIAccounts.vue?vue&type=style&index=0&id=0e1c00a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1c00a2",
  null
  
)

export default component.exports